import httpClient from 'axios'
import _ from 'underscore'
import axios from 'axios'
import 'url-search-params-polyfill'
import { forEach } from 'lodash'
import { killKeepAlive, keepAliveExists } from '@/services/keepAliveService'

var Buffer = require('buffer/').Buffer
const httpVerbs = ['POST', 'PATCH', 'PUT']
const deleteEpToSearchParams = ['/v2/auth-mod/mfa/profilePreference']

export { BasicClient }

class BasicClient {
  exec(
    urlSet?: string,
    methods?: string,
    paramsSet?: any,
    flagForParam?: boolean,
    deleteLoad?: any
  ) {
    let data: {}
    let config: any = {}
    if (paramsSet !== undefined) {
      if (_.contains(httpVerbs, methods)) {
        //Saque el PUT de aca. ---> YO lo agregue :p
        const params = flagForParam ? new FormData() : new URLSearchParams()
        for (let name in paramsSet) {
          let param: any = paramsSet[name]
          if (typeof param === 'object' && !(param instanceof Blob)) {
            param = JSON.stringify(paramsSet[name])
          }
          params.append(name, param)
        }
        data = { data: params }
      } else if (
        methods === 'DELETE' &&
        _.contains(deleteEpToSearchParams, urlSet)
      ) {
        const params = new URLSearchParams()
        for (let name in paramsSet) {
          let param: any = paramsSet[name]
          params.append(name, param)
        }
        data = { data: params }
      } else {
        data = { params: paramsSet }
      }
    }
    if (
      localStorage.jwt !== undefined &&
      localStorage.jwt !== null &&
      localStorage.jwt != 'null'
    ) {
      config = {
        headers: { Authorization: 'Bearer ' + localStorage.jwt },
        'Access-Control-Allow-Origin': '*',
      }
      if (flagForParam) {
        config.headers['Content-Type'] = 'multipart/form-data'
      }
    }

    return httpClient.request(
      _.extend(
        {
          url: urlSet,
          method: methods,
          baseURL: window.trcb.apiURL,
          // headers: header
        },
        data,
        config
      )
    )
  }
  getImage(uid) {
    let config = {
      responseType: 'arraybuffer',
      headers: {
        Authorization: 'Bearer ' + localStorage.jwt,
        Accept: 'application/pdf',
      },
    }
    return axios
      .get(window.trcb.apiURL + '/companies/logo/' + uid, config)
      .then((response) =>
        new Buffer(response.data, 'binary').toString('base64')
      )
  }
  renderImage(apiEndpoint) {
    return axios
      .get(window.trcb.apiURL + apiEndpoint, {
        responseType: 'arraybuffer',
        headers: { Authorization: 'Bearer ' + localStorage.jwt },
      })
      .then((response) => {
        return new Buffer(response.data, 'binary').toString('base64')
      })
  }
  downloadFile(apiUrl, inputParams) {
    const params = new FormData()
    forEach(inputParams, (value, key) => {
      let param = value
      if (typeof param === 'object' && !(param instanceof Blob)) {
        param = JSON.stringify(value)
      }
      params.append(key, param)
    })
    return axios.post(window.trcb.apiURL + apiUrl, params, {
      responseType: 'blob',
      headers: { Authorization: 'Bearer ' + localStorage.jwt },
    })
  }
  getDocumentPdf(app, appdoc, type, page) {
    let config = {
      responseType: 'arraybuffer',
      headers: { Authorization: 'Bearer ' + localStorage.jwt },
    }
    axios
      .get(
          window.trcb.apiURL +
          '/documents/view/' +
          app +
          '/' +
          appdoc +
          '/' +
          type +
          '/' +
          page,
        config
      )
      .then((res) => {
        // let blob:any = new Blob([res.data], { type: 'application/pdf' });
        // let url = window.URL.createObjectURL(blob)
        // window.open(url);
        var base64 = btoa(
          new Uint8Array(res.data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ''
          )
        )
        const linkSource = `data:application/pdf;base64,${base64}`
        const downloadLink = document.createElement('a')
        const fileName = 'file.pdf'

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      })
      .catch((error) => {
        console.log(error)
      })
  }

  downloadPdf(id, file, thumbnail = 1, base64 = 1) {
    let config = {
      responseType: 'arraybuffer',
      headers: { Authorization: 'Bearer ' + localStorage.jwt },
    }
    axios
      .get(
          window.trcb.apiURL +
          '/OnBoarding/OnBoardingFile?iduser=' +
          id +
          '&file=' +
          file +
          '&thumbnail=' +
          thumbnail +
          '&base64=' +
          base64,
        config
      )
      .then((res) => {
        var base64 = btoa(
          new Uint8Array(res.data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ''
          )
        )

        const a = document.createElement('a')
        document.body.appendChild(a)
        a.download = 'file.pdf'
        a.href = `data:application/pdf;base64,${base64}`
        a.click()

        // const linkSource = `data:application/pdf;base64,${base64}`;
        // const downloadLink = document.createElement("a");
        // const fileName = "file.pdf";

        // downloadLink.href = linkSource;
        // downloadLink.download = fileName;
        // downloadLink.click();
      })
      .catch((error) => {
        console.log(error)
      })
  }
  getFileJson(urlFile) {
    return axios
      .get(urlFile, {
        responseType: 'json',
        xsrfCookieName: 'XSRF-TOKEN',
        xsrfHeaderName: 'X-XSRF-TOKEN',
        headers: {
          Accept: 'application/json; odata=verbose'
        }
      })
      .then(response => {
        return response
      })
      .catch(error => {
        if (!error.response) {
          //axios network error not controller
        } else {
          return error
        }
      })
  }

  setCropPdf(apiEndpoint, inputParams) {
    const params = new FormData()
    forEach(inputParams, (value, key) => {
      let param = value
      if (typeof param === 'object' && !(param instanceof Blob)) {
        param = JSON.stringify(value)
      }
      params.append(key, param)
    })
    return axios
      .post(window.trcb.apiURL + apiEndpoint, params,{
        responseType: 'arraybuffer',
        headers: {
          Authorization: 'Bearer ' + localStorage.jwt,
          'Content-Type': 'multipart/form-data'
        },
      })
  }

  delete(urlSet?: string, paramsSet?: any) {
    const data: object = { data: paramsSet }
    let config: object = {}
    if (localStorage.jwt !== undefined && localStorage.jwt !== null && localStorage.jwt != 'null') {
      config = {
        headers: { Authorization: 'Bearer ' + localStorage.jwt },
        'Access-Control-Allow-Origin': '*',
      }
    }
    return httpClient.request(
        _.extend({ url: urlSet, method: 'DELETE', baseURL: window.trcb.apiURL,}, data, config)
    )
  }

  getFile(endpoint) {
    const config = {
      responseType: 'arraybuffer',
      headers: {
        Authorization: 'Bearer ' + localStorage.jwt,
        Accept: 'application/pdf',
      },
    }
    return axios.get(window.trcb.apiURL + endpoint, config)
  }
}

httpClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response.status === 401) {
      if (keepAliveExists()) killKeepAlive()
      if (window.location.pathname !== '/s/login') {
        const externalVueURL = [
          window.location.origin + '/keepalive',
          window.location.origin + '/keepaliveSecurity',
        ]
        if (externalVueURL.includes(error.config.url)) {
          return Promise.reject(error)
        } else {
          try {
            await axios.post(window.location.origin + `/salir`, null, {
              withCredentials: true
            })
          } catch (e) {
            console.error(e)
          }
          localStorage.removeItem('jwt')
          localStorage.removeItem('user')
          localStorage.removeItem('vuex')
          localStorage.removeItem('actions')
          localStorage.removeItem('hadModal')
          window.location.href = window.location.origin + '/s/login'
        }
      }
    }
    return Promise.reject(error)
  }
)
